<template>
  <div id="home">
    <Word />
  </div>
</template>

<script>
import Word from "../components/Word";

export default {
  name: "home",
  components: {
    Word
  }
};
</script>

<style>
#home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue